export default "__VITE_ASSET__CNbqwNsq__"